import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// //import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-upload-dpr',
  standalone: false,
  templateUrl: './upload-dpr.component.html',
  styleUrl: './upload-dpr.component.scss'
})
export class UploadDprComponent implements OnInit, OnDestroy {
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() step: any;
  @Input() id: any;
  @Input() proposalName: any;
  proposalForm!: FormGroup;
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: any;
  @Input() format: any;
  apiUrl = environment.APIUrl
  docuemntList: any;
  baseUrl = environment.APIUrl;
  winners:any;
  payload: {
    proposal_id: any;
    proposal_name: any;
    schemeId: any;
  };
  vendors: any
  private subscriptions = new Subscription();
  userID: any;
  constructor(private messageService: MessageService, private fb: FormBuilder, private api: ApiService, private route: ActivatedRoute,  private apiService: ApiService) {
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
   }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      const schemeId = params['scheme']
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
        schemeId: schemeId
      }
      // this.getDPR();
      this.getData(); // Call getData after payload is initialized
    });
    this.proposalForm = this.fb.group({
      comment: ['', Validators.required],
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  // getDPR() {
  //   const endpoint = this.schemeType == 'tdf' ? `/tdf/evaluation/tpr/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}` : `/make1/upload/dpr/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}&scheme=${this.payload.schemeId}`;

  //   const sub = this.api.getAPI(endpoint).subscribe((res: any) => {
  //     const vendorsData = res.da || res.vendor || {};
  //     const vendorMap = new Map();

  //     Object.keys(vendorsData).forEach((vendorName: string) => {
  //       const items = vendorsData[vendorName];
  //       const incubatorId = items?.[0]?.da?.id || null;
  //       const entries = items.map((item: any) => ({
  //         evaluationId: item.id,
  //         daId: item.da?.id, // ← required when submitting
  //         proposalStep: item.proposal_step,
  //         document: item.document,
  //         bid_document: item.bid_document,
  //         document_flag: item.document_flag,
  //         selectedFile: null
  //       }));

  //       vendorMap.set(vendorName, {
  //         name: vendorName,
  //         incubatorId: incubatorId,
  //         entries: entries
  //       });
  //     });

  //     this.vendors = Array.from(vendorMap.values());
  //   });
  //   this.subscriptions.add(sub);
  // }


  onFileSelect(event: any, criteria: any, type: 'dpr' | 'bid') {
    const file = event.files[0];

    if (type === 'dpr') {
      criteria.selectedDPRFile = file;
    } else {
      criteria.selectedBidFile = file;
    }
  }

  submitDocument(vendor: any, criteria: any, type: 'dpr' | 'bid') {
    const formData = new FormData();
    const file = type === 'dpr' ? criteria.selectedDPRFile : criteria.selectedBidFile;
    formData.append('vendor_eval_id', criteria.evaluationId);
    if (type == 'bid') {
      formData.append('bid_document', criteria.selectedBidFile);
    } else {
      formData.append('document', criteria.selectedDPRFile);
    }
    formData.append('document_flag', 'True');
    const endpoint = this.schemeType == 'tdf' ? `/tdf/evaluation/tpr/` : `/make1/upload/dpr/`
    const sub = this.api.putAPI(endpoint, formData).subscribe({
      next: (res) => {
        // this.getDPR();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document submitted' });
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Submission failed' });
      }
    });
    this.subscriptions.add(sub);
  }
  generatePDF() { }
     goToNextStep() {
    this.stepCompleted.emit();
  }
        activeIndex: number | null = null;
  togglePanel(index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
  }

    getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }

onMultipleFileUpload(event: any, row: any) {
  if (!row.tempDocuments) {
    row.tempDocuments = [];
  }

for (let file of event.files) {
    row.tempDocuments.push(file);
  }
}

 saveRow(row: any) {
  console.log(row)
  const formData = new FormData();
  let url;
 url = this.schemeType === 'tdf'
    ? `/tdf/evaluation/tpr/${row.evaluation}/`
    : `/make1/upload/dpr/${row.id}/`;

    if(this.schemeType == 'tdf'){
  if (row.tempDocuments?.length) {
    row.tempDocuments.forEach((file: File) => {
      formData.append('documents', file);
    });
  }
    }else{
        if (row.tempDocuments?.length) {
    row.tempDocuments.forEach((file: File) => {
      formData.append('document', file);
    });
  }
    }


  // vendor id goes inside body
  formData.append('vendor_eval_id', row.id);

  // evaluation id goes in URL
  const sub = this.apiService
    .putAPI(url, formData)
    .subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Vendor updated successfully',
        });
        this.getData(); // refresh the table
      },
      error: (err) => {
        console.error('Error updating vendor:', err);
      },
    });
}


getData() {
  if (!this.payload || !this.payload.proposal_id) {
    console.warn('Payload not initialized yet, skipping getData call');
    return;
  }

  const endpoint = this.schemeType === 'tdf'
    ? `/tdf/evaluation/tpr/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}`
    : `/make1/upload/dpr/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}`;

  const sub = this.apiService.getAPI(endpoint).subscribe((resp: any) => {
    this.docuemntList = resp;

    // Convert vendor object → array
    this.winners = Object.keys(resp.vendor).flatMap((vendorName: string) => {
      return resp.vendor[vendorName].map((row: any) => {
        row.vendor.name = vendorName;

        // ✅ Normalize documents
        if (Array.isArray(row.documents)) {
          // Case for TDF-like format
          row.documents = row.documents.map((doc: string) => ({
            fileId: doc,
            fileName: doc.split('/').pop()
          }));
        } else if (row.document) {
          // Case for Make-like format
          row.documents = [{
            fileId: row.document,
            fileName: row.document.split('/').pop()
          }];
        } else {
          row.documents = [];
        }

        return row;
      });
    });
  });

  this.subscriptions.add(sub);
}



    setStatus(vendor: any, status: 'Qualify' | 'Disqualify') {
    vendor.vendor_status = status;
    const formData = new FormData();
    formData.append('vendor_status', vendor.vendor_status);
    formData.append('vendor_eval_id', vendor.id);
 const url = this.schemeType === 'tdf'
    ? `/tdf/evaluation/tpr/`
    : `/make1/upload/dpr/`;

    const sub = this.apiService
      .putAPI(url, formData)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor updated successfully',
          });
          this.getData(); // refresh the table
        },
        error: (err) => {},
      });
  }
}
